import React, { useState } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";

const CustomMultiSelect = ({
  placeholder,
  options = [],
  dropdownValue,
  toggleCollectionOption,
  customClass,
  placeholderKey,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <DropdownMenu.Root open={open} onOpenChange={setOpen}>
      <div className="custom-multiselect-trigger-con">
        <DropdownMenu.Trigger
          className={`custom-multiselect-trigger ${
            customClass ? customClass : ""
          }`}
        >
          {(Array.isArray(dropdownValue) ? dropdownValue : [dropdownValue])
            .length > 0
            ? `${
                (Array.isArray(dropdownValue) ? dropdownValue : [dropdownValue])
                  .length
              } Selected ${placeholderKey}`
            : placeholder}
        </DropdownMenu.Trigger>
      </div>

      <DropdownMenu.Content
        className={`custom-multiselect-content ${
          customClass ? customClass : ""
        }`}
      >
        <div className="custom_multiselect_inner">
          {options.map((option) => (
            <DropdownMenu.CheckboxItem
              key={option.value}
              className={`custom-multiselect-item ${
                dropdownValue.includes(option.value) ? "selected" : ""
              }`}
              checked={dropdownValue.includes(option.value)}
              onCheckedChange={() => {
                toggleCollectionOption(option.value);
              }}
              onSelect={(e) => e.preventDefault()}
            >
              {option.label}
            </DropdownMenu.CheckboxItem>
          ))}
        </div>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export default CustomMultiSelect;
